import React, { Component } from "react";

import PageLayout from '../../components/layout/PageLayout'
import {ThemeProps} from "../../components/styles/themeprops";
import Greeting from "../../components/greeting/Greeting";
import Skills from "../../components/skills/Skills";

type Props = {
  theme: ThemeProps,
}
class Home extends Component<Props> {
  render() {
    return (
      <PageLayout title="Home" theme={this.props.theme}>
      	<Greeting theme={this.props.theme} />
      	<Skills theme={this.props.theme} />
      </PageLayout>
    );
  }
}

export default Home;
